export function cleanNumber(model, fieldName) {
  const donation =
    model.has(fieldName) && model.get(fieldName)
      ? Number(model.get(fieldName).replace(/[^0-9.-]+/g, ''))
      : 0
  return donation > 0 ? donation : 0
}
